import { render } from "./Dock.vue?vue&type=template&id=5579aae2&scoped=true"
import script from "./Dock.vue?vue&type=script&lang=js"
export * from "./Dock.vue?vue&type=script&lang=js"

import "./Dock.vue?vue&type=style&index=0&id=5579aae2&scoped=true&lang=scss"
import "./Dock.vue?vue&type=style&index=1&id=5579aae2&lang=css"

import exportComponent from "D:\\project\\2024\\htos\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5579aae2"]])

export default __exports__